import { Input, EventEmitter, Output, OnChanges, Directive } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { switchMap, mergeMap, map, tap } from 'rxjs/operators';
import { Course, Learnspace, LearnspaceMode, ListQueryOptions } from '@shared/models';
import { environment } from '@env/environment';
import { Hub } from '@shared/models/hub.model';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CurrentHubService } from '@shared/services/currentHub.service';

@Directive()
export abstract class CoursesListBaseComponent implements OnChanges {
  @Input() learnspaceCourse: Learnspace;
  @Input() canCreateCourse: boolean;
  @Output() onListChanged = new EventEmitter<any>();

  learnspace: Observable<Learnspace>;
  changes = new BehaviorSubject<{ action: string, content: Course | string }>({ action: '', content: null });
  coursesChange = this.changes.asObservable();
  roomUrl: string;
  hubObservable: Observable<Hub>;
  learnspaceList: Learnspace[];

  constructor(
    protected _courseApiService: CoursesAPIService,
    protected _currentHubService: CurrentHubService
  ) { }

  ngOnChanges(): void {
    this.roomUrl = environment.roomUrl;
    
    this._courseApiService.getLearnspacesByHub(this._currentHubService.hub.id, new ListQueryOptions('title')).subscribe(
      spaceList => this.learnspaceList = spaceList.learnspaces
    );

    this.learnspace = of(this.learnspaceCourse).pipe(
      mergeMap(ls => {
        return this.coursesChange.pipe(
          tap(change => {
            this.onListChanged.emit(change);
          }),
          switchMap(change => {
            if (change.action === 'remove') {
              return this._courseApiService.getLearnspaceById(this.learnspaceCourse.id);
            }
            if (change.action === 'add') {
              ls.courses.push(change.content as Course);
            } else if (change.action === 'update') {
              const index = ls.courses.findIndex(s => s.id === (change.content as Course).id);
              ls.courses[index] = (change.content as Course);
            }
            return of(ls);
          }),
          map(ls => {
            ls.courses.sort((courseA, courseB) => {
              if (ls.mode === LearnspaceMode.program) {
                return courseA.position - courseB.position;
              } else {
                return courseB.status.localeCompare(courseA.status) 
                  || (Date.parse(courseB.createdAt) - Date.parse(courseA.createdAt)) 
              }
            });
            return ls;
          })
        );
      })
    );
  }

  onListChange(event: { action: string, content: Course | string }){
    this.changes.next({ action: event.action, content: event.content });
  }
}
